import React, { useEffect } from 'react';
import withRouter from '../Components/Common/withRouter';
import { useProfile } from '../hooks/UserHooks';
import { Navigate } from 'react-router-dom';

//redux
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';

const NonAuthLayout = ({ children }: any) => {
    const { userProfile, token } = useProfile();

    const nonauthData = createSelector(
        (state) => state.Layout,
        (layout) => ({
            layoutModeType: layout.layoutModeType
        })
    );
    // Inside your component
    const { layoutModeType } = useSelector(nonauthData);

    useEffect(() => {
        if (layoutModeType === "dark") {
            document.body.setAttribute("data-bs-theme", "dark");
        } else {
            document.body.setAttribute("data-bs-theme", "light");
        }
        return () => {
            document.body.removeAttribute("data-bs-theme")
        }
    }, [layoutModeType]);

    if (userProfile && token) {
        return <Navigate to={window.innerWidth <= 1024 ? "/scanning" : "/dashboard"} replace />;
    }

    return (
        <div>
            {children}
        </div>
    );
};

export default withRouter(NonAuthLayout);